import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography, Box, Slide } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';
import { useI18n } from '../i18n/I18nProvider';

const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useI18n();

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <Slide direction="up" in={isVisible} mountOnEnter unmountOnExit>
            <Paper
                elevation={10}
                sx={{
                    position: 'fixed',
                    bottom: { xs: 16, sm: 24 },
                    left: { xs: 16, sm: 'auto' },
                    right: { xs: 16, sm: 24 },
                    maxWidth: { sm: 400 },
                    p: 3,
                    borderRadius: '16px',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(0, 0, 0, 0.05)',
                    zIndex: 9999,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                    <Box
                        sx={{
                            backgroundColor: '#f3e5f5',
                            p: 1,
                            borderRadius: '10px',
                            display: 'flex',
                        }}
                    >
                        <CookieIcon sx={{ color: '#7b1fa2' }} />
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700, color: '#1a1a1a', mb: 0.5 }}
                        >
                            {t('cookie.title')}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: '#5f6368', lineHeight: 1.6, mb: 2 }}
                        >
                            {t('cookie.body')}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1.5 }}>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleAccept}
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 3,
                                    py: 1,
                                    backgroundColor: '#7b1fa2',
                                    '&:hover': {
                                        backgroundColor: '#6a1b9a',
                                    },
                                }}
                            >
                                {t('cookie.accept')}
                            </Button>
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => setIsVisible(false)}
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    color: '#5f6368',
                                }}
                            >
                                {t('cookie.close')}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    );
};

export default CookieConsent;
